import { inject } from '@angular/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

const defaultPdfAssetsPath = 'assets/resources/pdf-viewer';

const getPdfAssetsPath = (context: ContextService): string => {
  if (context.integration) {
    return `${context.integration.url}/assets/resources/pdf-viewer`;
  }

  if (context.embedded) {
    return context.debug
      ? 'http://localhost:4200/assets/resources/pdf-viewer'
      : `${context.website}/ClientScript/AngularElements/assets/resources/pdf-viewer`;
  }

  return defaultPdfAssetsPath;
};

export const configurePdfDefaults = (): void => {
  const context = inject(ContextService);
  pdfDefaultOptions.assetsFolder = getPdfAssetsPath(context);
};
